<template lang="pug">

    .ui.grid

        .eight.wide.column
            button.ui.fluid.labeled.icon.button(v-on:click="requestConfirmation()")
                i.inbox.icon
                | Lieferanten-AB anfordern

        .eight.wide.column
            button.ui.fluid.right.labeled.icon.button(v-on:click="skipConfirmation()")
                i.forward.icon
                | Ohne Lieferanten-AB fortfahren

</template>

<script>

    export default {

        methods: {

            async requestConfirmation() {
                try {
                    // Ab-Request erstellen
                    const oCRModel = await this.$store.dispatch('orderConfirmationRequests/create', {
                        model: { price: this.priceModel.id }
                    })

                    // Preis & Uploadlink neu laden
                    // noinspection JSIgnoredPromiseFromCall
                    await Promise.all([
                        this.$store.dispatch('prices/loadOne', { id: this.priceModel.id, force: true }),
                        this.$store.dispatch('uploads/loadOne', { id: oCRModel.upload, force: true }),
                    ])

                    // Erfolgsmeldung
                    this.$growl.success('Auftragsbestätigung wurde angefordert')

                } catch (e) {
                    // Fehlermeldung anzeigen
                    this.$growl.fatal('Auftragsbestätigung konnte nicht angefordert werden', e)
                }

            },

            async skipConfirmation() {
                const patch = { isOrderConfirmationRequired: false }
                await this.$store.dispatch('prices/patch', { id: this.priceModel.id, patch })
            }

        },

        props: {

            priceModel: {
                type: Object,
                required: true
            },

        }

    }


</script>
